module.exports = __webpack_public_path__ + "img/segmentation.55e1e9a8.png";